import React, { useState } from "react";
import banner from "../assets/gravitebanner.webp";
import "../style/Gravite.css";

import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const Gravite = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    state: "",
    city: "",
    buyingTime: "",
    agree: false,
  });

  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState("success");
  const [popupMessage, setPopupMessage] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.agree) {
      setPopupType("error");
      setPopupMessage("Please accept the marketing consent.");
      setShowPopup(true);
      return;
    }

    try {
      await addDoc(collection(db, "graviteLeads"), {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        mobile: formData.mobile,
        state: formData.state,
        city: formData.city,
        buyingTime: formData.buyingTime,
        agree: formData.agree,
        offer: "Nissan Gravite",
        createdAt: serverTimestamp(),
      });

      setPopupType("success");
      setPopupMessage(
        "Thank you! Your details have been submitted successfully."
      );
      setShowPopup(true);

      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        mobile: "",
        state: "",
        city: "",
        buyingTime: "",
        agree: false,
      });
    } catch (error) {
      console.error(error);

      setPopupType("error");
      setPopupMessage("Something went wrong. Please try again.");
      setShowPopup(true);
    }
  };

  return (
    <div className="gravite-page">
      {/* HERO */}
      <div className="gravite-hero">
        <div className="hero-image">
          <img src={banner} alt="Nissan Gravite" />
        </div>

        <form className="lead-form" onSubmit={handleSubmit}>
          <h2>Get Expert Advice Now</h2>

          <input
            type="text"
            name="firstName"
            placeholder="First Name"
            value={formData.firstName}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="lastName"
            placeholder="Last Name"
            value={formData.lastName}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <input
            type="tel"
            name="mobile"
            placeholder="Mobile"
            value={formData.mobile}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="state"
            placeholder="State"
            value={formData.state}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="city"
            placeholder="City"
            value={formData.city}
            onChange={handleChange}
            required
          />

          <label className="small-label">
            How soon are you looking to buy?
          </label>

          <select
            name="buyingTime"
            value={formData.buyingTime}
            onChange={handleChange}
            required
          >
            <option value="">Select</option>
            <option value="Within 1 Month">Within 1 Month</option>
            <option value="1-3 Months">1-3 Months</option>
            <option value="3-6 Months">3-6 Months</option>
            <option value="6+ Months">6+ Months</option>
          </select>

          <div className="checkbox-row">
            <input
              type="checkbox"
              name="agree"
              checked={formData.agree}
              onChange={handleChange}
            />

            <span>
              By submitting this form, you agree that your data may be used for
              marketing purposes.
            </span>
          </div>

          <button type="submit" className="submit-btn">
            Submit
          </button>
        </form>
      </div>

      {/* ABOUT */}
      <section className="about-gravite">
        <h2>Experience the Nissan Gravite</h2>

        <p>
          Make your journey more comfortable, practical and memorable with the
          Nissan Gravite. Built for families who need more space, better
          comfort and smart features, it's designed to fit your everyday drives
          as well as your weekend getaways. From its bold road presence to its
          spacious 7-seater cabin, the Gravite is ready to be your perfect
          travel partner.
        </p>
      </section>

      {/* TABLE */}
      <section className="tech-data">
        <h2>Technical Data for the Nissan Gravite Variants</h2>

        <table>
          <thead>
            <tr>
              <th>Specification</th>
              <th>VISIA</th>
              <th>ACENTA</th>
              <th>N-CONNECTA</th>
              <th>TEKNA</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>Ex-Showroom Price</td>
              <td>₹5,73,400</td>
              <td>₹6,68,400</td>
              <td>₹7,38,400</td>
              <td>₹8,08,000</td>
            </tr>

            <tr>
              <td>Headlamp Setup</td>
              <td>Projector</td>
              <td>Projector</td>
              <td>Projector</td>
              <td>Signature LED</td>
            </tr>

            <tr>
              <td>Infotainment</td>
              <td>Standard Audio</td>
              <td>20.32cm Touchscreen</td>
              <td>20.32cm Touchscreen</td>
              <td>20.32cm Touchscreen</td>
            </tr>

            <tr>
              <td>Connectivity</td>
              <td>Bluetooth</td>
              <td>Android Auto & Apple CarPlay</td>
              <td>Android Auto & Apple CarPlay</td>
              <td>Android Auto & Apple CarPlay</td>
            </tr>

            <tr>
              <td>Safety</td>
              <td>6 Airbags</td>
              <td>6 Airbags</td>
              <td>6 Airbags</td>
              <td>6 Airbags</td>
            </tr>
          </tbody>
        </table>
      </section>

      {/* CUSTOM POPUP */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div
              className={`popup-icon ${
                popupType === "success" ? "success" : "error"
              }`}
            >
              {popupType === "success" ? "✓" : "✕"}
            </div>

            <h3>
              {popupType === "success"
                ? "Submitted Successfully"
                : "Submission Failed"}
            </h3>

            <p>{popupMessage}</p>

            <button
              className="popup-btn"
              onClick={() => setShowPopup(false)}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gravite;